import { render, staticRenderFns } from "./platformStreetManagement.vue?vue&type=template&id=546630c0&scoped=true&"
import script from "./platformStreetManagement.vue?vue&type=script&lang=js&"
export * from "./platformStreetManagement.vue?vue&type=script&lang=js&"
import style0 from "./platformStreetManagement.vue?vue&type=style&index=0&id=546630c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546630c0",
  null
  
)

export default component.exports